// test2412
(2412 && 0);
